import * as Yup from 'yup';

export type FieldError = {
  isValid: boolean;
  errorMessage: string;
};

// helper: все поля объекта должны иметь FieldError
type WithFieldError<T extends object> = {
  [K in keyof T]: T[K] & FieldError;
};

export async function checkValidate<T extends object>(
  validationData: WithFieldError<T>,
  validationSchema: Yup.ObjectSchema<any>
): Promise<{ validate: boolean; newObj: WithFieldError<T> }> {
  try {
    await validationSchema.validate(validationData, {
      abortEarly: false,
      context: validationData,
    });

    return { validate: true, newObj: validationData };
  } catch (e) {
    const yupError = e as Yup.ValidationError;

    const patch = yupError.inner.reduce<Partial<WithFieldError<T>>>((acc, err) => {
      const key = err.path?.split('.')[0] as keyof T | undefined;
      if (!key || acc[key]) return acc;

      acc[key] = {
        ...validationData[key],
        isValid: false,
        errorMessage: err.message,
      };

      return acc;
    }, {});

    return {
      validate: false,
      newObj: { ...validationData, ...patch },
    };
  }
}
